export default class {
    constructor(channelName) {
        this.socket = null
        this.channelName = channelName
        this.firstJoin = true
        this.latestEventId = null
        this.callbacks = {}
    }

    connect(socket, callback = null) {
        this.socket = socket
        this.channel = this.socket.channel(this.channelName)

        this.channel
            .join()
            .receive('ok', async () => {
                if (this.firstJoin) {
                    let sequence = await this.fastlane('broadcast:latest_sequence_id')
                    if (this.latestEventId) return

                    if (sequence.id) {
                        this.latestEventId = sequence.id
                    } else {
                        this.latestEventId = 0
                    }
                }

                if (callback) callback()

                this.firstJoin = false
            })
            .receive('error', res => {
                console.log('Não foi possível se juntar ao canal: ' + this.channelName)
            })

        this.channel.on('broadcast:event', dados => {
            console.log(dados)

            // dados.id deve ser igual ao próximo número da sequência ou "1", que significa que expirou o cache e recomeçou a contagem.
            if (
                this.latestEventId === null ||
                (this.latestEventId !== null && (dados.id == this.latestEventId + 1 || dados.id === 1))
            ) {
                this.latestEventId = dados.id

                this.invocarCallbacksDoEvento(dados['event'], dados['data'])
            } else {
                this.replayEvents()
            }
        })
    }

    leave() {
        this.channel.leave()
        this.latestEventId = null
    }

    delegateCallbacks(channel) {
        this.delegateCallbacksChannel = channel
    }

    replayEvents() {
        console.log('Replay events...')

        this.fastlane('broadcast:replay_de_eventos', { id: this.latestEventId }, { retry: true }).then(
            ({ eventos }) => {
                if (eventos.length >= 50) {
                    // this.store.commit('atualizarStatusWebsocket', 'inconsistente')
                }

                eventos.forEach(dados => {
                    this.latestEventId = dados.id
                    this.invocarCallbacksDoEvento(dados['event'], dados['data'])
                })
            }
        )
    }

    invocarCallbacksDoEvento(evento, dados) {
        if (this.delegateCallbacksChannel) {
            this.delegateCallbacksChannel.invocarCallbacksDoEvento(evento, dados)
            return
        }

        if (evento in this.callbacks) {
            let callbacks = this.callbacks[evento]
            callbacks.forEach(callback => callback(dados))
        } else {
            throw new Error('Não há nenhum callback registrado para o evento de websocket: ' + evento)
        }
    }

    on(evento, callback) {
        if (this.callbacks[evento]) {
            this.callbacks[evento].push(callback)
        } else {
            this.callbacks[evento] = [callback]
        }
    }

    off(evento, callback) {
        this.callbacks[evento] = this.callbacks[evento].filter(c => c != callback)
    }

    fastlane(evento, dados, opts = {}) {
        return new Promise((resolve, reject) => {
            if (typeof jest !== 'undefined') {
                return resolve(mockedFastlane[evento])
            }

            let retries = 6

            const run = () => {
                retries -= 1
                if (retries <= 0) {
                    return reject('Max retries')
                }

                this.channel
                    .push(evento, dados)
                    .receive('ok', resposta => {
                        resolve(resposta)
                    })
                    .receive('error', err => {
                        reject(err)
                    })
                    .receive('timeout', () => {
                        if (opts.retry) {
                            setTimeout(() => {
                                run()
                            }, 1000)
                        } else {
                            reject('timeout')
                        }
                    })
            }

            run()
        })
    }
}

/**
 * Mapa com {nome_do_evento -> mocked_response} usado no Jest.
 *
 * @var {{[key]: string}: any}
 */
const mockedFastlane = {}

/**
 * Atualiza uma resposta fake para o fastlane para facilitar testes do Jest.
 *
 * @param {string} evento
 * @param {*} resposta
 */
export function mockFastlane(evento, resposta) {
    mockedFastlane[evento] = resposta
}
